import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const DrillingMachine: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 300h-100v-30h70c16.57 0 30 13.43 30 30z' />
    <path d='m325 300h-115s0-30 0-30h90c16.57 0 30 13.43 30 30z' />
    <path d='m570 360h-120v-30h90v-75c0-8.27-6.73-15-15-15h-75v-30h75c24.81 0 45 20.19 45 45z' />
    <path d='m377.43 390h-257.43v-210h257.43l102.57 34.19v141.62zm-227.43-30h222.57l77.43-25.81v-98.38l-77.43-25.81h-222.57z' />
    <path d='m241.78 600h-120.88l58.08-238.13 29.15 7.11-49.03 201.02h59.12l50.76-208.13 29.15 7.11z' />
    <path d='m352.09 371.64-20.89 78.36h-23.88l-7.32 30h54.25l26.83-100.63z' />
  </IconBase>
));

DrillingMachine.displayName = 'DrillingMachine';

export default DrillingMachine;
